import cls from 'classnames';
import { useRef } from 'react';

import pauseIcon from '../../../assets/Edit/pause.svg';
import playIcon from '../../../assets/Edit/play.svg';
import { useExposeItem } from '../../../hooks';
import { formatDuration } from '../../../utils/media';
import { LocalImage } from '../../Image';
import { IVoiceEditEntryProps } from '../voice';
import styles from '../voice.module.scss';

export function VoiceValue(
  props: IVoiceEditEntryProps & {
    buttons: React.ReactNode;
    isPlay: boolean;
    selected?: boolean;
    voiceName: string;
    voiceUrl: string;
    tagList: string[];
    handleVoiceClick: (url: string) => void;
    onClick?: () => void;
    styleOverrides?: {
      readonly [key: string]: string;
    };
    duration?: number;
    /** 静态属性 */
    onExpose?: () => void;
  }
) {
  const {
    buttons,
    isPlay,
    voiceName,
    tagList,
    selected,
    voiceUrl,
    handleVoiceClick,
    onClick,
    onExpose = () => {},
  } = props;

  const innerStyles = props.styleOverrides || styles;

  const divRef = useRef<HTMLDivElement | null>(null);

  useExposeItem({
    key: voiceUrl,
    ref: divRef,
    onExpose,
  });

  return (
    <div
      ref={divRef}
      className={cls(innerStyles.voiceValue, { [innerStyles.selectedVoice]: selected })}
      onClick={() => {
        onClick?.();
        handleVoiceClick(voiceUrl);
      }}
    >
      <div className={innerStyles.left}>
        <div
          className={innerStyles.playWrapper}
          onClick={() => {
            handleVoiceClick(voiceUrl);
          }}
        >
          <LocalImage src={isPlay ? pauseIcon : playIcon} />
        </div>
        <div className={innerStyles.info}>
          <div className={innerStyles.name}>{voiceName}</div>
          {(props.duration || tagList.length > 0) && (
            <div className={innerStyles.tags}>
              {props.duration ? (
                <div className={innerStyles.duration}>{formatDuration(props.duration)}</div>
              ) : null}
              {tagList.map((item) => (
                <div key={item} className={innerStyles.tag}>
                  {item}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {/* 避免点击按钮触发父元素的点击事件 */}
      <div className={innerStyles.voiceBtns} onClick={(e) => e.stopPropagation()}>
        {buttons}
      </div>
    </div>
  );
}
